<template>
  <div class="wrapper-btns">
    <el-button
      size="mini"
      v-for="item in list"
      :key="item"
      :type="val === item ? 'primary' : ''"
      @click="handleClick(item)"
    >
      {{ item }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'vBtnGroup',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: ''
    };
  },
  created() {
    this.val = this.value;
  },
  methods: {
    handleClick(val) {
      this.val = val;
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-btns {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/cuscom/btns-group.vue